import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetPlaceHolderModel } from './widget-place-holder.model';
import { WidgetLayoutService } from '@fi-shared/widget/widget-layout.service';
import { Inject } from '@angular/core';

export class WidgetAdministrateModel {
    Id: number;
    ModuleType: any;
    PlaceHolderCollection: WidgetPlaceHolderModel[];
    BaseUrl: string;
    PreviewFileName: string;
    ChangedOn: any;
    SiteDesignId: number;

    constructor(
        @Inject(WidgetLayoutService) private widgetLayoutService: WidgetLayoutService,
        data?,
    ) {
        if (!isDefined(data)) {
            data = {};
        }

        this.InitWidgetAdministrate(data);
    }

    InitWidgetAdministrate(data) {
        this.Id = data.Id;
        this.ModuleType = data.ModuleType;
        this.SiteDesignId = data.SiteDesignId;
        this.PlaceHolderCollection = [];
        if (data.PlaceHolderCollection) {
            this.PlaceHolderCollection = data.PlaceHolderCollection.map((item) => new WidgetPlaceHolderModel(item));
        }

        if (data.BaseUrl && data.BaseUrl.length > 0) {
            this.BaseUrl = data.BaseUrl;
            this.UpdatePlaceHolderCollection(this.widgetLayoutService.getLayoutById(this.BaseUrl));
        }

        this.PreviewFileName = data.PreviewFileName;
        this.ChangedOn = data.ChangedOn;
    }

    SetLayout(Layout) {
        this.BaseUrl = Layout.Id;
        this.UpdatePlaceHolderCollection(Layout);
    }

    UpdatePlaceHolderCollection(Layout) {
        // add new placeholders if there are more placeholders in new layout
        if (Layout.Placeholders.length > this.PlaceHolderCollection.length) {
            for (var i = this.PlaceHolderCollection.length; i < Layout.Placeholders.length; i++) {
                var newPlaceholder = new WidgetPlaceHolderModel();
                newPlaceholder.Properties.Number = Layout.Placeholders[i];
                this.PlaceHolderCollection.push(newPlaceholder);
            }
        }
        // remove placeholders if there are less placeholders count in new layout
        else if (Layout.Placeholders.length < this.PlaceHolderCollection.length) {
            var lastPlaceholder = this.PlaceHolderCollection[Layout.Placeholders.length - 1];
            for (var j = Layout.Placeholders.length; j < this.PlaceHolderCollection.length; j++) {
                lastPlaceholder.ControlCollection = lastPlaceholder.ControlCollection.concat(
                    this.PlaceHolderCollection[j].ControlCollection,
                );
            }
            this.PlaceHolderCollection.length = Layout.Placeholders.length;
        }

        for (var k = 0; k < this.PlaceHolderCollection.length; k++) {
            this.PlaceHolderCollection[k].Properties.Number = Layout.Placeholders[k];
        }
    }

    FindPlaceholderByNumber(Number) {
        for (var i = 0; i < this.PlaceHolderCollection.length; i++) {
            if (this.PlaceHolderCollection[i].Properties.Number == Number) {
                return this.PlaceHolderCollection[i];
            }
        }
    }
}
